var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Navbar"),
      _c(
        "div",
        { staticClass: "step-page" },
        [
          _vm._m(0),
          _vm._m(1),
          _c(
            "el-tabs",
            {
              staticClass: "tab-component",
              attrs: {
                "tab-position": _vm.windowWidth > 1024 ? "left" : "top",
              },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "面談背景資料", name: "面談背景資料" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish: _vm.resumeCompleteness.IsIDLWorkedInfoComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 面談背景資料"),
                        _c("br"),
                        _vm._v(" Interview background "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg mt-1" },
                    [
                      _vm.activeName === "面談背景資料"
                        ? _c("WorkedInfo", {
                            key: _vm.workedInfoKey,
                            attrs: { source: "resume", nextTab: "個人資料" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "個人資料", name: "個人資料" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish: _vm.resumeCompleteness.IsIDLBaseInfoComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 個人資料"),
                        _c("br"),
                        _vm._v(" Personal information "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg" },
                    [
                      _c("div", { staticClass: "step-tip mb-2" }, [
                        _vm._v(
                          " ** 以下任何欄位皆基於工作所需而請求應徵者提供，若認為涉及個人資料而不願透漏，可選擇不填。"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "en-text" }, [
                          _vm._v(
                            "The applicant must fill out the following fields based on job requirements, if do not want to disclose personal information, can select not to fill out."
                          ),
                        ]),
                      ]),
                      _vm.activeName === "個人資料"
                        ? _c("BaseInfo", {
                            key: _vm.baseInfoKey,
                            attrs: { source: "resume", nextTab: "學歷" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c("el-tab-pane", { attrs: { label: "學歷", name: "學歷" } }, [
                _c(
                  "span",
                  {
                    staticClass: "resume-tab",
                    class: {
                      finish: _vm.resumeCompleteness.IsIDLEducationComplete,
                    },
                    attrs: { slot: "label" },
                    slot: "label",
                  },
                  [
                    _c("span", { staticClass: "tab-name" }, [
                      _vm._v(" 學歷"),
                      _c("br"),
                      _vm._v(" Education "),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _c("div", { staticClass: "step-tip mb-2" }, [
                      _vm._v(
                        " ** 請至少提供一項已經修業完成的學歷，並從最高學歷開始填寫，且至少提供一項已經修業完成的學歷，而若資料庫中無您的母校，請直接填寫校名。"
                      ),
                      _c("br"),
                      _c("span", { staticClass: "en-text" }, [
                        _vm._v(
                          "Please provide at least one degree that has been completed."
                        ),
                      ]),
                    ]),
                    _vm.activeName === "學歷"
                      ? _c("Education", {
                          key: _vm.educationKey,
                          attrs: { source: "resume", nextTab: "工作經歷" },
                          on: { changeTab: _vm.changeTab },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c(
                "el-tab-pane",
                { attrs: { label: "工作經歷", name: "工作經歷" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish:
                          _vm.resumeCompleteness.IsIDLWorkExperienceComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 工作經歷"),
                        _c("br"),
                        _vm._v(" Work Experience "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg" },
                    [
                      _c("div", { staticClass: "step-tip mb-2" }, [
                        _vm._v(
                          " ** 請從最近一份工作經歷開始填起，「薪資」請填寫阿拉伯數字，例如：「29,000」。"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "en-text" }, [
                          _vm._v(
                            'Please start from the most recent work experience. Please fill in Arabic numerals for "Salary", for example: "29,000 ".'
                          ),
                        ]),
                      ]),
                      _vm.activeName === "工作經歷"
                        ? _c("WorkExperience", {
                            key: _vm.workExperienceKey,
                            attrs: { source: "resume", nextTab: "專業技能" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "專業技能", name: "專業技能" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish: _vm.resumeCompleteness.IsIDLSkillComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 專業技能"),
                        _c("br"),
                        _vm._v(" Professional Skills "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg mt-1" },
                    [
                      _vm.activeName === "專業技能"
                        ? _c("Skill", {
                            key: _vm.skillKey,
                            attrs: { source: "resume", nextTab: "活動經驗" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "活動經驗", name: "活動經驗" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish:
                          _vm.resumeCompleteness
                            .IsIDLActivityExperienceComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 活動經驗"),
                        _c("br"),
                        _vm._v(" Activity Experience "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg mt-1" },
                    [
                      _vm.activeName === "活動經驗"
                        ? _c("Activity", {
                            key: _vm.activityKey,
                            attrs: { source: "resume", nextTab: "語言能力" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "語言能力", name: "語言能力" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish: _vm.resumeCompleteness.IsIDLLanguageComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 語言能力"),
                        _c("br"),
                        _vm._v(" Language Ability "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg" },
                    [
                      _c("div", { staticClass: "step-tip mb-2" }, [
                        _vm._v(
                          " ** 請用優、良、可、劣四個等級來評比自己聽、說、讀、寫的能力。"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "en-text" }, [
                          _vm._v(
                            " Please use Excellent, Good, Fair, Inferior four grades to compare your listening, speaking, reading and writing ability. "
                          ),
                        ]),
                      ]),
                      _vm.activeName === "語言能力"
                        ? _c("Language", {
                            key: _vm.languageKey,
                            attrs: { source: "resume", nextTab: "工作配合" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "工作配合", name: "工作配合" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish:
                          _vm.resumeCompleteness.IsIDLWorkCooperationComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 工作配合"),
                        _c("br"),
                        _vm._v(" Work Cooperation "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg mt-1" },
                    [
                      _vm.activeName === "工作配合"
                        ? _c("WorkCooperation", {
                            key: _vm.workCooperationKey,
                            attrs: { source: "resume", nextTab: "面試情況" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "面試情況", name: "面試情況" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish:
                          _vm.resumeCompleteness.IsIDLInterviewInfoComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 面試情況"),
                        _c("br"),
                        _vm._v(" Interview condition "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg" },
                    [
                      _c("div", { staticClass: "step-tip mb-2" }, [
                        _vm._v(" ** 請列出您最近參加面試的工作職缺情況。"),
                        _c("br"),
                        _c("span", { staticClass: "en-text" }, [
                          _vm._v(
                            "Please list your most recent job opening application interview circumstances."
                          ),
                        ]),
                      ]),
                      _vm.activeName === "面試情況"
                        ? _c("InterviewStatus", {
                            key: _vm.interviewStatusKey,
                            attrs: { source: "resume", nextTab: "職缺需求" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "職缺需求", name: "職缺需求" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish: _vm.resumeCompleteness.IsIDLWorkConsideration,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 職缺需求"),
                        _c("br"),
                        _vm._v(" Job vacancies "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg" },
                    [
                      _c("div", { staticClass: "step-tip mb-2" }, [
                        _vm._v(
                          " ** 請選擇您應徵此工作職缺的需求：《請依重要性，於每個項目下方排序第1~第10順位，並說明重視原因》"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "en-text" }, [
                          _vm._v(
                            ' Please select the job occupations you need to apply for: "Please rank each item from first to tenth according to the importance, and explain its importance" '
                          ),
                        ]),
                      ]),
                      _vm.activeName === "職缺需求"
                        ? _c("WorkConsideration", {
                            key: _vm.workConsiderationKey,
                            attrs: { source: "resume", nextTab: "保密義務" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "保密義務", name: "保密義務" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish: _vm.resumeCompleteness.IsIDLNDAComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 保密義務"),
                        _c("br"),
                        _vm._v(" Confidential duty "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg" },
                    [
                      _c("div", { staticClass: "step-tip mb-2" }, [
                        _vm._v(
                          " 註：「保密義務」是指您對於前雇主的機密資訊負有保密責任，離職之後不得繼續使用、揭露或持有。"
                        ),
                        _c("br"),
                        _vm._v(
                          " ** 提醒您，以下說明內容應真確詳實，並與您所簽訂的保密義務條款相同。"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "en-text" }, [
                          _vm._v(
                            ' Remark: "Confidentiality Obligation" means that you are obliged to keep confidential the confidential information of your former employer, and you must not continue to use, disclose or hold it after you leave your job. '
                          ),
                        ]),
                      ]),
                      _vm.activeName === "保密義務"
                        ? _c("Confidentiality", {
                            key: _vm.confidentialityKey,
                            attrs: {
                              source: "resume",
                              nextTab: "競業禁止限制",
                            },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c(
                "el-tab-pane",
                { attrs: { label: "競業禁止限制", name: "競業禁止限制" } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "resume-tab",
                      class: {
                        finish: _vm.resumeCompleteness.IsIDLNCCComplete,
                      },
                      attrs: { slot: "label" },
                      slot: "label",
                    },
                    [
                      _c("span", { staticClass: "tab-name" }, [
                        _vm._v(" 競業禁止限制"),
                        _c("br"),
                        _vm._v(" Non competition restriction "),
                      ]),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "step-content no-bg" },
                    [
                      _c("div", { staticClass: "step-tip mb-2" }, [
                        _vm._v(
                          " 註：「競業禁止」是指您曾與前雇主約定，在離職後的一定期間內，不能受雇於與該前雇主之營業性質相同或類似的工作。"
                        ),
                        _c("br"),
                        _vm._v(
                          " ** 提醒您，以下說明內容應真確詳實，並與您所簽訂的競業禁止條款相同。"
                        ),
                        _c("br"),
                        _c("span", { staticClass: "en-text" }, [
                          _vm._v(
                            ' Remark: "Non-competition" means that you have agreed with your former employer that within a certain period of time after leaving the job, you cannot be employed in a job with the same or similar business nature as that of the former employer. '
                          ),
                        ]),
                      ]),
                      _vm.activeName === "競業禁止限制"
                        ? _c("NonCompete", {
                            key: _vm.nonCompeteKey,
                            attrs: { source: "resume", nextTab: "智財" },
                            on: { changeTab: _vm.changeTab },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              ),
              _c("el-tab-pane", { attrs: { label: "智財", name: "智財" } }, [
                _c(
                  "span",
                  {
                    staticClass: "resume-tab",
                    class: { finish: _vm.resumeCompleteness.IsIDLIPComplete },
                    attrs: { slot: "label" },
                    slot: "label",
                  },
                  [
                    _c("span", { staticClass: "tab-name" }, [
                      _vm._v(" 智財"),
                      _c("br"),
                      _vm._v(" Intellectual properties exist "),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "step-content no-bg mt-1" },
                  [
                    _vm.activeName === "智財"
                      ? _c("IntellectualProperty", {
                          key: _vm.intellectualPropertyKey,
                          attrs: { source: "resume", nextTab: "自傳" },
                          on: { changeTab: _vm.changeTab },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _c("el-tab-pane", { attrs: { label: "自傳", name: "自傳" } }, [
                _c(
                  "span",
                  {
                    staticClass: "resume-tab",
                    class: {
                      finish: _vm.resumeCompleteness.IsIDLAutobiographyComplete,
                    },
                    attrs: { slot: "label" },
                    slot: "label",
                  },
                  [
                    _c("span", { staticClass: "tab-name" }, [
                      _vm._v(" 自傳"),
                      _c("br"),
                      _vm._v(" Autobiography "),
                    ]),
                  ]
                ),
                _c(
                  "div",
                  { staticClass: "step-content no-bg" },
                  [
                    _vm.activeName === "自傳"
                      ? _c("Autobiography", {
                          key: _vm.autobiographyKey,
                          attrs: { source: "resume" },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c(
        "span",
        { staticStyle: { "font-size": "1.8rem", "font-weight": "bold" } },
        [_vm._v("IDL 間接人員人事資料表")]
      ),
      _c("br"),
      _c("span", { staticClass: "en-text" }, [
        _vm._v("IDL staff HR information form"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title" }, [
      _c("span", { staticStyle: { "font-weight": "bold" } }, [
        _vm._v("應徵工程職務、管理職務與其他後勤職務"),
        _c("br"),
      ]),
      _c("span", { staticClass: "en-text" }, [
        _vm._v(
          "Apply for engineering jobs, managerial duties and other logistic jobs"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }